import apiService from "@/core/services/apiService";

export type State = { classes: object };
import {Module, VuexModule, Mutation, Action} from "vuex-module-decorators";
import {Actions, Mutations} from "@/store/enums/store.enums";
import {BenefitsActions, BenefitsMutation} from "@/modules/benefits/store/enums";

@Module
export default class Store extends VuexModule {
    settings = [];
    topics = [];

    get getBenefitsSettings() {
        return this.settings;
    }

    get getBenefitsTopics() {
        return this.topics;
    }

    @Mutation
    [BenefitsMutation.SET_SETTINGS_RESULT](settings) {
        this.settings = settings;
    }

    @Mutation
    [BenefitsMutation.SET_TOPICS_RESULT](topics) {
        this.topics = topics;
    }

    @Action
    [BenefitsActions.FETCH_SETTINGS]() {

        return new Promise<void>((resolve, reject) => {

            apiService.get("content/get-reference-settings/benefit").then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(BenefitsMutation.SET_SETTINGS_RESULT, data.result);
                resolve();

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [BenefitsActions.CREATE_SETTING](payload) {

        return new Promise((resolve, reject) => {

            apiService.post('content/create-reference-setting', payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(BenefitsActions.FETCH_SETTINGS);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [BenefitsActions.UPDATE_SETTING](payload) {

        return new Promise((resolve, reject) => {

            const {settingsId, data: settingData} = payload;

            apiService.put(`content/update-reference-setting/${settingsId}`, settingData).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(BenefitsActions.FETCH_SETTINGS);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [BenefitsActions.DELETE_SETTING](settingsId) {

        return new Promise((resolve, reject) => {

            apiService.delete(`content/delete-reference-setting/${settingsId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(BenefitsActions.FETCH_SETTINGS);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [BenefitsActions.FETCH_TOPICS]() {

        return new Promise<void>((resolve, reject) => {

            apiService.get("content/get-reference-topics/benefit").then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(BenefitsMutation.SET_TOPICS_RESULT, data.result);
                resolve();

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [BenefitsActions.CREATE_TOPIC](payload) {

        return new Promise((resolve, reject) => {

            apiService.post('content/create-reference-topic', payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(BenefitsActions.FETCH_TOPICS);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [BenefitsActions.UPDATE_TOPIC](payload) {

        return new Promise((resolve, reject) => {

            const {topicId, data: topicData} = payload;

            apiService.put(`content/update-reference-topic/${topicId}`, topicData).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(BenefitsActions.FETCH_TOPICS);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [BenefitsActions.DELETE_TOPIC](topicId) {

        return new Promise((resolve, reject) => {

            apiService.delete(`content/delete-reference-topic/${topicId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(BenefitsActions.FETCH_TOPICS);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [BenefitsActions.REORDER_TOPICS](payload) {

        return new Promise((resolve, reject) => {

            apiService.put('content/reorder-reference-topics', payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(BenefitsActions.FETCH_TOPICS);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

}
